export enum PcsInformationConstants {
  NOT_IMPLEMENTED = 'pcsInformation/NOT_IMPLEMENTED',
  SET_NPPFORMGIVEN = 'pcsInformation/SET_NPPFORMGIVEN',
  SET_CONSENTFORMSIGNED = 'pcsInformation/SET_CONSENTFORMSIGNED',
  SET_MEDICALNECESSITYSIGNED = 'pcsInformation/SET_MEDICALNECESSITYSIGNED',
  SET_PCSREASON = 'pcsInformation/SET_PCSREASON',
  SET_PCSPROVIDERTYPE = 'pcsInformation/SET_PCSPROVIDERTYPE',
  SET_LASTNAME = 'pcsInformation/SET_LASTNAME',
  SET_FIRSTNAME = 'pcsInformation/SET_FIRSTNAME',
  SET_MILESTOHOSP = 'pcsInformation/SET_MILESTOHOSP',
  SET_PCSSIGNEDTIME = 'pcsInformation/SET_PCSSIGNEDTIME',
  SET_PCSSIGNEDDATE = 'pcsInformation/SET_PCSSIGNEDDATE',
  SAVE_PCSINFORMATION = 'pcsInformation/SAVE_PCSINFORMATION',
  SET_RESPONSE = 'pcsInformation/SET_RESPONSE',
  RESET_PCSINFORMATION_STATE = 'pcsInformation/RESET_PCSINFORMATION_STATE',
  SET_PCSINFORMATION = 'pcsInformation/SET_PCSINFORMATION',
  ADD_CURRENT_TIME = 'pcsInformation/ADD_CURRENT_TIME',
}
